// utils/orderUtils.ts

import { Order } from "src/shared/services/interfacev2";
import { PaymentData } from "../../types/order";

export const clearPaymentInput = (): PaymentData => ({
  discount: "",
  ReceivedAmount: "",
  paymentMethod: "",
});

export const handlePaymentInputChange = (e: React.ChangeEvent<HTMLInputElement>, order: Order | null, setPaymentData: React.Dispatch<React.SetStateAction<PaymentData>>) => {
  const { name, value } = e.target;
  const remainingAmount = (order?.orders[0].remainingAmount ?? "0");

  if (value === "" || /^\d*\.?\d*$/.test(value)) {
    const inputAsNumber = parseFloat(value || "0");
    if (!isNaN(inputAsNumber) && inputAsNumber <= Number(remainingAmount)) {
      setPaymentData((prev) => ({ ...prev, [name]: value }));
    }
  }
};

export const formatDate = (date: Date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

export const formatTime = (date: Date) =>
  `${String(date.getHours()).padStart(2, "0")}:` +
  `${String(date.getMinutes()).padStart(2, "0")}:` +
  `${String(date.getSeconds()).padStart(2, "0")}`;

